import { render, staticRenderFns } from "./ClosePlayingButton.vue?vue&type=template&id=2c747d18&scoped=true&"
import script from "./ClosePlayingButton.vue?vue&type=script&lang=js&"
export * from "./ClosePlayingButton.vue?vue&type=script&lang=js&"
import style0 from "./ClosePlayingButton.vue?vue&type=style&index=0&id=2c747d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c747d18",
  null
  
)

export default component.exports